
























import Vue from 'vue';
import MusicCard from '@/components/MusicCard.vue';
import { Track } from '@/interfaces/track';

export default Vue.extend({
  name: 'home',
  components: {
    MusicCard,
  },
  data() {
    return {
      key: 0,
    };
  },
  methods: {
    shuffle() {
      this.$store.dispatch('shuffleFavorite');
    },
  },
  computed: {
    random(): Track {
      return this.$store.state.RANDOM_FAVORITE;
    },
  },
});
